"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Svg = __importStar(require("react-native-svg"));
exports.default = (props) => (<Svg.Svg {...props} viewBox='0 0 24 24'>
    <Svg.G data-name='Layer 2'>
      <Svg.G data-name='keypad'>
        <Svg.Rect width='24' height='24' opacity='0'/>
        <Svg.Path d='M5 2a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'/>
        <Svg.Path d='M12 2a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'/>
        <Svg.Path d='M19 8a3 3 0 1 0-3-3 3 3 0 0 0 3 3z'/>
        <Svg.Path d='M5 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'/>
        <Svg.Path d='M12 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'/>
        <Svg.Path d='M19 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'/>
        <Svg.Path d='M5 16a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'/>
        <Svg.Path d='M12 16a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'/>
        <Svg.Path d='M19 16a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'/>
      </Svg.G>
    </Svg.G>
  </Svg.Svg>);
//# sourceMappingURL=Keypad.js.map